import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type { QuickValidateRequestActionPayload } from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { QuickValidationResponse } from '../../../../../../shared/types/roi-hub/fileIngestion.types';

const QuickValidate = new ReduxAsyncAction<
  'FILE_INGESTOR_QUICK_VALIDATE',
  QuickValidateRequestActionPayload,
  QuickValidationResponse
>('FILE_INGESTOR_QUICK_VALIDATE');

QuickValidate.registerRequest(async (payload) => {
  try {
    const { data } = await dash_api.post<QuickValidationResponse>('/v1/roi/file-ingestor/quick-validate', payload);
    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when quick validating file', 'error');
    throw error;
  }
});

export const QUICK_VALIDATE = QuickValidate.actionNamespaceConstants;

export const quickValidate = QuickValidate.request;

export type QuickValidateResponseAction = Action<typeof QUICK_VALIDATE.response>;
